import { api } from "./client";
import type { DeployTarget, Detect, LabelClass, Project } from "./types";

export const listProjects = () => api.get<Project[]>("/projects");
export const createProject = (name: string, description = "", threshold = 100) =>
  api.post<Project>("/projects", { json: { name, description, autotrain_threshold: threshold } });
export const updateProject = (id: number, patch: Partial<Pick<Project, "name" | "description" | "autotrain_threshold">>) =>
  api.put<Project>(`/projects/${id}`, { json: patch });
export const getProject = (id: number) => api.get<Project>(`/projects/${id}`);
export const deleteProject = (id: number) => api.del<void>(`/projects/${id}`);
/** What the project's model finds and where it runs. Admins only (permission "configure"). */
export const setProjectSetup = (id: number, setup: { detect: Detect; deploy_target: DeployTarget }) =>
  api.put<Project>(`/projects/${id}/setup`, { json: setup });

export const listClasses = (pid: number) => api.get<LabelClass[]>(`/projects/${pid}/classes`);
export const createClass = (pid: number, name: string, color_hex = "#FF6B35") =>
  api.post<LabelClass>(`/projects/${pid}/classes`, { json: { name, color_hex } });
export const updateClass = (pid: number, cid: number, patch: { name?: string; color_hex?: string }) =>
  api.put<LabelClass>(`/projects/${pid}/classes/${cid}`, { json: patch });
export const deleteClass = (pid: number, cid: number) => api.del<void>(`/projects/${pid}/classes/${cid}`);
/** Relabel every annotation of `sourceId` as `targetId` and remove the source class. */
export const mergeClass = (pid: number, targetId: number, sourceId: number) =>
  api.post<LabelClass>(`/projects/${pid}/classes/${targetId}/merge`, { json: { source_id: sourceId } });
